import React, {useEffect, useRef, useState} from 'react';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';

const ToggleDetails = ({text, limit}) => {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);
  useEffect(() => {
    if (expanded) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight('60px'); // collapsed height (approx. 3 lines)
    }
  }, [expanded, text]);

  const [height, setHeight] = useState('auto');

  if (!text) return '';

  if (!text) {
    return '';
  }

  let _d = text.split(' ');

  const isLongText = _d.length > limit;

  let _e = '';
  for (let i = 0; i < _d.length && i < limit; i++) {
    _e += (i === 0 ? '' : ' ') + _d[i];
  }
  const toggleText = () => {
    setExpanded(!expanded);
  };

  const displayText = isLongText && !expanded ? _e + '...' : text;

  return (
    <div className="toggle-wrapper" style={{height}}>
      <div
        className={`toggle-content ${expanded ? 'expanded' : 'collapsed'}`}
        ref={contentRef}
      >
        {displayText}
      </div>
      {isLongText && (
        <a href={"#"}
           onClick={(e) => {
             e.preventDefault();
             toggleText();
           }}
           style={{fontSize: '18px', cursor: 'pointer', marginLeft: '5px', float: 'right', position:'absolute', bottom: '0', right:'5px'}}
        >
          {expanded ? <ExpandCircleDownIcon sx={{
            transform: 'rotate(180deg)'
          }}/> : <ExpandCircleDownIcon/>}
        </a>
      )}
    </div>
  );
};

export default ToggleDetails;
